import {mapApiError} from "../../shared/api/errors";

const MAX_MESSAGE_LENGTH = 500;

export const mapUserApiError = (error) => {
    const backendMessage = error?.response?.data?.message;
    const mapped = mapApiError(error);
    if (typeof backendMessage !== "string" || !backendMessage.trim()) return mapped;
    return {...mapped, message: backendMessage.trim().slice(0, MAX_MESSAGE_LENGTH)};
};
